import type { StateType } from 'typesafe-actions';

import type { GuardedFunction } from 'src/modules/ConfirmModal/types';
import type reducer from './reducer';

export const isOpened = (state: StateType<typeof reducer>): boolean => state.isOpened;

export const getText = (state: StateType<typeof reducer>): string | null => state.text;

export const getTitle = (state: StateType<typeof reducer>): string | null => state.title;

export const getConfirmButtonTitle = (state: StateType<typeof reducer>): string | null => state.confirmButton;

export const getCancelButtonTitle = (state: StateType<typeof reducer>): string | null => state.cancelButton;

export const getGuardedFunction = (state: StateType<typeof reducer>): GuardedFunction | null => state.guardedFunction;
